import paymentProgress from '@/asset/images/payment-progress.svg';
import paymentFailedProgress from '@/asset/images/payment-failed-progress.svg';
import { Typography } from '@/components/ui/typography';
import { IconComponent } from '@/util/icons';

export const PaymentProgressLoader = () => (
  <div className="flex flex-col items-center gap-3 py-4 text-center">
    <IconComponent src={paymentProgress} alt="" />
    <Typography as="h2" variant="heading-lg">
      Order Request in Progress
    </Typography>
    <Typography as="p" variant="body" className="text-muted-foreground">
      Please remain on this page while we process your order. This window will
      close once the order is processed successfully.
    </Typography>
  </div>
);

export const PaymentFailedProgressLoader = () => (
  <div className="flex flex-col items-center gap-3 py-4 text-center">
    <IconComponent src={paymentFailedProgress} alt="" />
    <Typography as="h2" variant="heading-lg">
      Order Request Failed
    </Typography>
    <Typography as="p" variant="body" className="text-muted-foreground">
      Please check the card details and try again.
    </Typography>
  </div>
);
